




























































































































































import { Component, Vue } from 'vue-property-decorator'
import { countTodoGroup, listTodoGroup, updateTodoGroup } from '@/api/todo'
import moment from 'moment'
import { ITodoGroup } from '@/types/todo/types'
import Nav from '@/components/navbar/index.vue'
import { createUrl, getUser } from '@/api/user'
import { todoGroupFilterArray, todoGroupList, todoGroupPriorities, todoGroupStatusGroup } from '@/constant/todoConstant'
import { GROUP_ID, MAX_TIME, USER } from '@/constant/storageConstant'
import TodoNav from '@/views/todo/component/TodoNav.vue'
import { cvtTimeMillisByDateTimeStr, originalStartDay, startDateTimeStr } from '@/utils/time'
import { filterHandlerMethod } from '@/utils/table'

@Component({
  name: 'TodoGroupList',
  components: {
    Nav,
    TodoNav
  }
})
export default class extends Vue {
  private todoGroupList: ITodoGroup[] = todoGroupList
  private listLoading = true
  private editLoading = false
  private shareUrlVisible = false
  private shareUrl = ''
  private todoGroupFormVisible = false
  private todoGroupForm: any = {}
  private pendingTodoGroup: ITodoGroup | undefined
  private priorities = todoGroupPriorities

  private currentPage = 1
  private pageSizes = ['10', '20', '50', '100']
  private pageSize = 10
  private pageCount = 5
  private total = 10
  private todoGroupStatusGroup = todoGroupStatusGroup
  private dateTimeRange: string[] | null = []
  private status = 1
  private filterArray = todoGroupFilterArray
  private filterHandler = filterHandlerMethod

  mounted () {
    this.dateTimeRange = [
      originalStartDay(),
      startDateTimeStr(moment().add(1, 'days'))
    ]

    // html加载完成后执行。执行顺序：子组件-父组件
    const isLogin = localStorage.getItem(USER) !== null
    if (!isLogin) {
      this.getUserAndInitData()
    } else {
      this.initData()
    }
  }

  private async initData () {
    // 已登录，加载初始数据
    const status = await this.getTodoGroupList()
    if (status) {
      // 获取数据总量
      await this.getTodoGroupTotal()
    }
  }

  private async getUserAndInitData () {
    const result = await getUser()
    if (result.status) {
      localStorage.setItem(USER, JSON.stringify(result.data))
      await this.initData()
    }
  }

  private async getTodoGroupTotal () {
    const startTime = this.dateTimeRange !== null ? cvtTimeMillisByDateTimeStr(this.dateTimeRange[0]) : undefined
    const endTime = this.dateTimeRange !== null ? cvtTimeMillisByDateTimeStr(this.dateTimeRange[1]) : undefined
    const status = this.status !== 0 ? this.status : undefined
    const param = {
      startTime: startTime,
      endTime: endTime,
      status: status
    }
    const result = await countTodoGroup(param)
    if (result.status) {
      this.total = result.data
    }
  }

  private handleSizeChange (val: number) {
    this.pageSize = val
  }

  private handleCurrentChange (val: number) {
    this.currentPage = val
    this.getTodoGroupList()
  }

  private descCreateTime (createTime: number) {
    return moment(createTime).format('YYYY-MM-DD HH:mm:ss')
  }

  private descStatus (status: number) {
    return status === 1 ? '进行中' : status === 50 ? '已删除' : '已完成'
  }

  private async handleDetails (row: any) {
    localStorage.setItem(GROUP_ID, row.id)
    localStorage.setItem(MAX_TIME, row.maxTime)
    await this.$router.push({
      path: '/todoList'
    })
  }

  private handleEdit (todoGroup: ITodoGroup) {
    this.todoGroupForm = {
      id: todoGroup.id,
      maxTime: todoGroup.maxTime,
      minPriority: todoGroup.minPriority
    }
    this.pendingTodoGroup = todoGroup
    this.todoGroupFormVisible = true
  }

  private async submitEdit () {
    this.editLoading = true
    if (this.pendingTodoGroup !== undefined &&
      (this.pendingTodoGroup.maxTime !== this.todoGroupForm.maxTime ||
        this.pendingTodoGroup.minPriority !== this.todoGroupForm.minPriority)) {
      const param = {
        id: this.todoGroupForm.id,
        maxTime: undefined,
        minPriority: undefined
      }
      if (this.pendingTodoGroup.maxTime !== this.todoGroupForm.maxTime) {
        param.maxTime = this.todoGroupForm.maxTime
      }
      if (this.pendingTodoGroup.minPriority !== this.todoGroupForm.minPriority) {
        param.minPriority = this.todoGroupForm.minPriority
      }
      const result = await updateTodoGroup(param)
      if (result.status) {
        if (param.maxTime !== undefined) {
          this.pendingTodoGroup.maxTime = result.data.maxTime
        }
        if (param.minPriority !== undefined) {
          this.pendingTodoGroup.minPriority = result.data.minPriority
        }

        this.$message.success('修改成功')
      }
    }
    this.todoGroupFormVisible = false
    this.editLoading = false
  }

  private async handleShare (todoGroup: ITodoGroup) {
    this.shareUrlVisible = true
    const param = {
      url: location.protocol + '//' + location.host + '/#/todoList',
      groupId: todoGroup.id
    }
    const result = await createUrl(param)
    if (result.status) {
      this.shareUrl = result.data
    }
  }

  private async getTodoGroupList () {
    this.listLoading = true
    const startTime = this.dateTimeRange !== null ? cvtTimeMillisByDateTimeStr(this.dateTimeRange[0]) : undefined
    const endTime = this.dateTimeRange !== null ? cvtTimeMillisByDateTimeStr(this.dateTimeRange[1]) : undefined
    const param = {
      offset: (this.currentPage - 1) * this.pageSize,
      count: this.pageSize,
      startTime: startTime,
      endTime: endTime,
      status: this.status,
      sort: 'desc',
    }
    const result = await listTodoGroup(param)
    // 拉取数据时要清空原来的数据
    this.todoGroupList.splice(0, this.todoGroupList.length)
    if (result.status) {
      for (let t of result.data) {
        const todoGroup = {
          id: t.id,
          createTime: t.createTime,
          totalValue: t.value,
          finishValue: t.finishValue,
          totalTime: t.totalTime,
          maxTime: t.maxTime,
          minPriority: t.minPriority,
          updateDateTime: moment(t.updateTime).format('YYYY-MM-DD HH:mm:ss'),
          status: t.status
        }
        this.todoGroupList.push(todoGroup)
      }
    }
    this.listLoading = false
    return result.status
  }

  private searchList () {
    this.getTodoGroupList()
    this.getTodoGroupTotal()
  }
}
